module.exports = __webpack_public_path__ + "static/media/BalanceIcon.af303f23.svg";